import shubham from "../Components/Assets/shubham.webp";
import Utkarsh_Sri from "../Components/Assets/Utkarsh_Sri.webp";
import Suraj_k from "../Components/Assets/Suraj.jpeg";
import Shishir from "../Components/Assets/Shishir.jpeg";

var chats = [
  {
    name: "Sandipan (Y21)",
    work: "Data Scientist at Kotak Bank",
    text: "Hello everyone! I'm Sandipan (Y21) a recent B.Tech graduate from Civil Engineering department. ",
    dp: "placement-postulates/blogs/Sandipan/6.JPG",
    link: "/Sandipan",
    thumbnail: "",
    og: "/Sandipan",
    year: "y21",
  },
  {
    name: "Shishir (Y21)",
    work: "SDE at American Express",
    text: "Hello everyone! I'm Shishir (Y21) a recent B.Tech graduate from Civil Engineering department. ",
    dp: Shishir,
    link: "/Shishir",
    thumbnail: "",
    og: "/Shishir",
    year: "y21",
  },
  {
    name: "Suraj Kumar (Y21)",
    work: "Godrej Properties Limited (GPL)",
    text: "Hello everyone! I'm Suraj Kumar (Y21) a recent B.Tech graduate from Civil Engineering department. ",
    dp: Suraj_k,
    link: "/Suraj",
    thumbnail: "",
    og: "/Suraj",
    year: "y21",
  },
  {
    name: "Utkarsh Srivastava (Y20)",
    work: "Data Analyst at ICICI Bank",
    text: "Hello everyone! I'm Utkarsh Srivastava (Y20) a recent B.Tech graduate from Civil Engineering department. ",
    dp: Utkarsh_Sri,
    link: "/utkarsh",
    thumbnail: "",
    og: "/utkarsh",
    year: "y20",
  },
  {
    name: "Shubham kumar (Y20)",
    work: "Larsen & Toubro Limited",
    text: "  Hi, I’m Shubham, and I got placed as a Management Trainee at Larsen and Toubro.",
    dp: shubham,
    link: "/shubham",
    thumbnail: "",
    og: "/Shubham-kumar",
    year: "y20",
  },
  {
    name: "Arush Kumar Rai (Y20)",
    work: "Tata Projects Limited",
    text: " Hi everyone, I'm Arush, a Y20 BT-CE student, currently placed at Tata Projects Limited (TPL).",
    dp: "placement-postulates/dp/Arush-Kumar-Rai.jpg",
    link: "/Arush",
    thumbnail: "",
    og: "/Arush_Y20",
    year: "y20",
  },
  {
    name: "Ajeet kushwaha (Y20)",
    work: "Deloitte",
    text: " Hi everyone. Myself Ajeet Kushwaha and I’m placed in Deloitte as a consultant.This is my story of how I navigated my way to placement. ",
    dp: "placement-postulates/dp/Ajeet-khushwaha.jpg",
    link: "/ajeet_kushwaha",
    thumbnail: "",
    og: "/Ajeet_kushwaha_Y20",
    year: "y20",
  }, {
    name: "Prajakta Kapre(Y22)",
    work: "HILTI",
    text: " Hi everyone I am Prajakta Kapre, currently placed in HILTI company in the Value Engineering hub as Technical Engineer-1.",
    dp: "placement-postulates/dp/Prajakta.png",
    link: "/Prajakta",
    thumbnail: "",
    og: "/Prajakta",
    year: "y22",
  },
  {
    name: "Miska Singh(Y22)",
    work: "Accenture AI",
    text: " Hello everyone! This is Miska Singh, currently working as a Decision Science Analyst at Accenture AI. As a member of the Y22 batch, I specialized in Transportation Engineering.",
    dp:"placement-postulates/dp/Miska-Singh.jpg",
    link: "/Miska",
    thumbnail: "",
    og: "/Miska",
    year: "y22",
  },
  {
    name: "Ashish (Y19)",
    work: "Tata Projects Limited",
    text: " Hi! This is Ashish, a Y19 BT-CE, currently placed in Tata Projects Limited (TPL). Through this blog, I share my journey from submitting my resume after deadline extension to securing an offer at TPL",
    dp: "placement-postulates/dp/Ashish-Singh.jpg",
    link: "/ashish",
    thumbnail: "",
    og: "/Ashish_Singh",
    year: "y19",
  },
  {
    name: "Ayush Dwivedi (Y19)",
    work: "Piramal Finance",
    text: " Hello everyone, I am  Ayush Dwivedi currently a Final Year Undergraduate in the Department of Civil Engineering at IIT Kanpur. I got placed as SDE (Software Development Engineer) at Piramal Finance and will be joining in the upcoming summers. Many of you must be knowing me as your Department Academic Mentor. Through this postulate, I would like to take you to my internship and placement journey, the challenges which I faced and most importantly how can one grab a good placement offer by doing smart work.",
    dp: "placement-postulates/dp/Ayush-Dwidevi.jpg",
    link: "/ayush_dwivedi",
    thumbnail: "",
    og: "/Ayush_Dwivedi",
    year: "y19",
  },
  {
    name: "Aditya Gupta (Y19)",
    work: "Squarepoint Capital(Montreal)",
    text: " Hello everyone, I am Aditya Gupta, a Y19 BT/CE student, and I will be joining Squarepoint Capital as a Software Engineer in Paris. Over the past four years of my journey at IIT Kanpur",
    dp: "placement-postulates/dp/Aditya-Gupta.jpg",
    link: "/aditya_gupta",
    thumbnail: "",
    og: "/Aditya_Gupta",
    year: "y19",
  },
  {
    name: "Srajan Jain (Y19)",
    work: "Morgan Stanley",
    text: "Hello everyone, I am Srajan Jain, a final year UG student in civil engineering, currently placed in Morgan Stanley for the Sales and Trading Associate role. Through this blog, I want to share my college journey by focusing on the placement side of it.Hey everyone! I am Sandipan Mitra (Y19, CE), and I got an offer from Auronova Consulting in the Analyst profile on Day 2 of the Placement season 2022-23.",
    dp: "placement-postulates/dp/Srajan-Jain.jpg",
    link: "/srajan_jain",
    thumbnail: "",
    og: "/Srajan_Jain",
    year: "y19",
  },
  {
    name: "Meet Saiya (Y21-MT)",
    work: "AECOM India",
    text: "I’m Meet, final year M. Tech in Infrastructure Engineering and Management. My placement journey has been one hell of a rollercoaster ride,",
    dp: "placement-postulates/dp/Meet-Saiya.jpg",
    link: "/meet_saiya",
    thumbnail: "",
    og: "/Meet_Saiya",
    year: "pg",
  },
  {
    name: "Sandipan Mitra (Y19)",
    work: "Auronova Consulting",
    text: "Hey everyone! I am Sandipan Mitra (Y19, CE), and I got an offer from Auronova Consulting in the Analyst profile on Day 2 of the Placement season 2022-23.",
    dp: "placement-postulates/dp/Sandipan-Mitra.jpg",
    link: "/sandipan_mitra",
    thumbnail: "",
    og: "/Sandipan_Mitra",
    year: "y19",
  },
  {
    name: "Ankit Kumar (Y18)",
    work: "Myntra",
    text: "Hello everyone!    Since you have reached here, so you know who I am. So, skipping the formal introduction part, I would like to clear it in the very beginning that if you are the one who has been academically well throughout your time at IITK or you are the one who always got what you wanted easily then this blog isn’t for you. This blog is for the people who are tensed about their career but don’t know what to do or for the people who are doubting themselves if they will be getting placed or not. Also, you may think that I am writing this very late according to the placements timeline but as mentioned above, the people for whom I am writing this must be really worried about placements from the last few weeks only. And yes, these ‘people’ can be from any batches, be it Y19 sitting in the placements or be it Y21, I would try my best to state things very clearly without any diplomacy.",
    dp: "placement-postulates/dp/Ankit-Kumar.JPG",
    link: "/ankit",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/28.jpg",
    og: "/Ankit_Kumar",
    year: "y18",
  },
  {
    name: "Himanshu Mishra (Y18)",
    work: "Accenture",
    text: "Hello everyone,    I am Himanshu Mishra, will be joining Accenture Japan as a Digital Consultant. My 4 years (practically 2.5 years) at IIT Kanpur is just as exhilarating, with ups and downs like a roller coaster ride. There were thrilling moments mixed in with tense, anxious, frightened and triumphant ones. The college years are a truly surprising and delightful time in our lives, when we make numerous friends, finalize our careers, and prepare for the trials of the real world. But, if I have to conclude in one word, I will say “Life at campus is Beautiful”",
    dp: "placement-postulates/dp/Himanshu-Mishra.jpg",
    link: "/himanshu_mishra",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/27.png",
    og: "/Himanshu_Mishra",
    year: "y18",
  },
  {
    name: "Aryaman Shandilya (Y18)",
    work: "Zomato",
    text: "Hey everyone, I am Aryaman Shandilya. I am a Y18 BT/CE student, and I am currently working as an Associate Product Manager at Zomato. Through this piece, I will try my best to help you prepare for your placements. While this may apply more to some than others, I hope every one who is taking the time out to read this is able to take something out of this.",
    dp: "placement-postulates/blogs/Aryaman-Shandilya/1.jpg",
    link: "/aryaman_shandilya",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/26.png",
    og: "Aryaman_Shandilya",
    year: "y18",
  },
  {
    name: "Yash Vardhan Raizada (Y18)",
    work: "Microsoft",
    text: "Hi there! I am Yash Vardhan Raizada, currently a Final Year Undergraduate in the Department of Civil Engineering at IIT Kanpur. In the upcoming summers, after graduating, I will be joining Microsoft as a full-time employee in the role of Software Engineer.",
    dp: "placement-postulates/dp/Yashvardhan.jpg",
    link: "/yashvardhan_raizada",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/25.png",
    og: "Yashvardhan_Raizada",
    year: "y18",
  },
  {
    name: "Gaurav Jiwan (Y18)",
    work: "PwC",
    text: "Hi there! I am Gaurav Jiwan (Y18, CE) and was placed in PwC in their consulting practice during the 2021-22 placement season. The previous accounts on the SoCE page have done an exceptional job in explaining the technicalities of placements and I highly recommend going through them.",
    dp: "placement-postulates/dp/Gaurav-Jiwan.jpg",
    link: "/gaurav_jiwan",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/24.png",
    og: "Gaurav_Jiwan",
    year: "y18",
  },
  {
    name: "Aditya Dikshit (Y18)",
    work: "Accenture Strategy",
    text: "Hello everyone ,    I am Aditya Dikshit, a final year undergraduate (Y18) in Civil Engineering. I have secured an Associate role at Accenture Strategy in Phase 1 of the placement season 2021-22.",
    dp: "placement-postulates/dp/Aditya-Dikshit.jpg",
    link: "/aditya_dikshit",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/23.jpg",
    og: "Aditya_Dikshit",
    year: "y18",
  },

  {
    name: "Samyak Jain (Y18)",
    work: "Amazon",
    text: "Hi Everyone; I am Samyak Jain, a senior undergrad in Civil Engineering. I am currently placed at Amazon as a Software Development Engineer-I (SDE-I).",
    dp: "placement-postulates/dp/Samyak-Jain-Y18.jpg",
    link: "/samyak18",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/22.jpg",
    og: "Samyak_Jain_18",
    year: "y18",
  },

  {
    name: "Piyush Senwar (Y18)",
    work: "Micron Technology",
    text: "Hi everyone, this is Piyush Senwar, who will be joining Micron Technology as an Associate Data Science Engineer. Through this postulate, I would like to take you to my placement journey, what challenges I faced, a bit of my journey on how I got into data science,",
    dp: "placement-postulates/dp/Piyush.jpg",
    link: "/piyush_senwar",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/21.jpg",
    og: "Piyush_Senwar",
    year: "y18",
  },
  {
    name: "Mradul Chaudhary (Y18)",
    work: "Samagra",
    text: "Hi, I am Mradul Chaudhary, incoming associate consultant at Samagra. 2 Most important attributes that flipped cards for me were Confidence and Communication. My placement experience will be a little different from other blogs because I got placed off-campus before placement season.",
    dp: "placement-postulates/dp/Mradul-Chaudhary.jpg",
    link: "/mradul_chaudhary",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/20.jpg",
    og: "Mradul_Chaudhary",
    year: "y18",
  },

  {
    name: "Neha Aggarwal (Y18)",
    work: "Zomato",
    text: "I am Neha Aggarwal, a final year undergraduate majoring in Civil Engineering and hoping to complete my minors in IME. I will be joining Zomato as a Product Engineer (SDE 1). In my 3rd year summers, I did a Data Science internship in Mobileum Inc which was not from campus internship season.",
    dp: "placement-postulates/dp/Neha.jpg",
    link: "/neha_aggarwal",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/19.jpg",
    og: "Neha_Aggarwal",
    year: "y18",
  },

  {
    name: "Naman Jain (Y18)",
    work: "Clear Tax",
    text: "Hello everyone, this is Naman Jain, a final year undergraduate student pursuing Civil Engineering currently placed in Clear Tax as Business Analyst. This postulate will be more focused on my experience rather than preparation tips. Honestly, I don’t have much to share on the preparation side, as I did the minimalist preparation possible.",
    dp: "placement-postulates/dp/Naman-Jain.jpg",
    link: "/naman_jain",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/18.jpg",
    og: "Naman_Jain",
    year: "y18",
  },

  {
    name: "Yashkrit Gupta (Y18)",
    work: "Barclays",
    text: "Hey Everyone, This is Yashkrit Gupta, a Final year UG student in civil engineering, currently placed in Barclays for the Quantitative Analyst role. Through this blog, I would love to share the journey of my placement season. This blog will be centered around my experience.",
    dp: "placement-postulates/dp/Yashkrit-Gupta.jpg",
    link: "/yashkrit_gupta",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/17.jpg",
    og: "Yashkrit_Gupta",
    year: "y18",
  },

  {
    name: "Dishant Parewa (Y17)",
    work: "IIFL",
    text: "Greetings Everyone! My name is Dishant Parewa, currently placed as a Software Developer at IIFL and today I am going to share my story. I hope many students will relate to it.",
    dp: "placement-postulates/dp/Dishant-Parewa.jpg",
    link: "/dishant_parewa",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/16.jpg",
    og: "Dishant_Parewa",
    year: "y17",
  },

  {
    name: "Mudit Kumar (Y17)",
    work: "PayU",
    text: "Greetings Everyone! I am Mudit Kumar, Y17 B.Tech in Civil Engineering student, placed in PayU as a Data Scientist. Talking about my academic background, I had a pretty bad start as I had an SPI of 6.6 in my 1st sem.",
    dp: "placement-postulates/dp/Mudit-Kumar.jpg",
    link: "/mudit_kumar",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/15.jpg",
    og: "Mudit_Kumar",
    year: "y17",
  },

  {
    name: "Rahul Gauriyar (Y16)",
    work: "JioSaavn",
    text: "Greetings Everyone! I am Rahul Gauriyar, Y16 BT-MT Dual Degree student, placed in JioSaavn as Software Engineer this year. I spent the first two years in a carefree, casual manner relishing every moment, getting high on TV series",
    dp: "placement-postulates/dp/Rahul-Gauriyar.jpg",
    link: "/rahul_gauriyar",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/14.jpg",
    og: "Rahul_Gauriyar",
    year: "y16",
  },

  {
    name: "Gourav Kamboj (Y17)",
    work: "HSBC",
    text: "Placement and Internship are the most frequent words that keep howling in our mind probably after the 2nd year and sometimes leaving no space to think of anything else. This phase comes in the life of the majority of us if not all.",
    dp: "placement-postulates/dp/Gaurav-Kamboj.jpg",
    link: "/gaurav_kamboj",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/13.jpg",
    og: "Gaurav_Kamboj",
    year: "y17",
  },

  {
    name: "Krishna Deo (Y17)",
    work: "Sutra Management Consultancies",
    text: "Greetings Everyone! I am Krishna Deo(Y17). I completed my Btech in Civil engineering(from IITK, obviously) this year. I will be joining Sutra Management Consultancies as a Business Analyst. In my 3rd Year, I did my Internship at ZestMoney as a Product Management intern(SPO se lagi thi). ",
    dp: "placement-postulates/dp/Krishna-Deo.jpg",
    link: "/krishna_deo",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/12.jpg",
    og: "Krishna_Deo",
    year: "y17",
  },

  {
    name: "Vineet Shukla (Y17)",
    work: "Groww",
    text: "Greetings Everyone! I am Vineet Shukla, a Y17 Civil Engineering student currently hustling through all major formalities of the final semester at IITK. I am at home, for now, struggling to recover my lost sense of smell and taste, waiting for my joining, and convincing people to write in my yearbook.",
    dp: "placement-postulates/dp/Vineet-Shukla.jpg",
    link: "/vineet_shukla",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/11.jpg",
    og: "Vineet_Shukla",
    year: "y17",
  },

  {
    name: "Rajat Ghoshal (Y17)",
    work: "Hilabs Inc.",
    text: "Hello Everyone! I am Rajat Ghoshal, a Final Year Undergraduate (Y17) in Civil Engineering, hoping for minors in IME and ML (a retrospective one :p). About academics - with a CPI just enough for distinction",
    dp: "placement-postulates/dp/Rajat-Ghosal.jpg",
    link: "/rajat_ghoshal",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/10.jpg",
    og: "Rajat_Ghoshal",
    year: "y17",
  },

  {
    name: "Samyak Jain (Y17)",
    work: "BFSI",
    text: "Hello Everyone! I am Samyak Jain, a final year undergraduate in Civil Engineering. I am currently placed at Navi technologies, a startup in the BFSI industry, as a Software developer.",
    dp: "placement-postulates/dp/Samyak-Jain.jpg",
    link: "/samyak_jain",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/9.jpg",
    og: "Samyak_Jain",
    year: "y17",
  },

  {
    name: "Shashi Shekhar (Y17)",
    work: "Blackrock",
    text: "Hi people! Let me share my story. So, I am Shashi Shekhar. I got placed in Blackrock on Day 1 during the placement season 20-21. My extra-curricular involvements changed with every year, but the major ones have been Manager- Research, Academics and Career Council and Senator, Y17.",
    dp: "placement-postulates/dp/Shashi-Shekhar.jpg",
    link: "/shashi_shekhar",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/8.jpg",
    og: "Shashi_Shekhar",
    year: "y17",
  },

  {
    name: "Vishal Agarwal (Y17)",
    work: "MTX",
    text: "Hello Everyone! My name is Vishal Agarwal (Y17, CE), currently placed at MTX Group and today I am going to give you a student’s perspective, something really honest and straightforward because that’s an element often missing in the talks that are given by the companies.",
    dp: "placement-postulates/dp/Vishal-Agarwal.jpg",
    link: "/vishal_agarwal",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/7.jpg",
    og: "Vishal_Agarwal",
    year: "y17",
  },

  {
    name: "Krishan Kumar (Y17)",
    work: "Sterlite Technology",
    text: "Starting with a brief intro of mine, I am Krishan Kumar, Y17 BT Civil Engineering. I got Placed on Day 2 in a Company named Sterlite Technology in my very first interview.",
    dp: "placement-postulates/dp/Krishan-Kumar.jpg",
    link: "/krishan_kumar",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/6.jpg",
    og: "Krishan_Kumar",
    year: "y17",
  },

  {
    name: "Dishaa Rajora (Y17)",
    work: "PWC",
    text: "Before I begin with the story of my placement journey, let us have introductions first. Hi. I am Dishaa Rajora, final year undergraduate majoring in Civil Engineering (wow, this introduction gave me formal-email-to-professor-don’t-know-how-to-begin-the-email feel).",
    dp: "placement-postulates/dp/Disha-Rajora.jpg",
    link: "/dishaa_rajora",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/5.jpg",
    og: "Dishaa_Rajora",
    year: "y17",
  },

  {
    name: "Ashutosh Ranjan (Y17)",
    work: "TATA Projects Limited",
    text: "Hello Everyone! My name is Ashutosh Ranjan, Y17, BTech in Civil Engineering, IITK. First, I will give a brief introduction about my curriculum. I am a fourth-year student and got placed in TATA Projects Limited in placement season 2020-21.",
    dp: "placement-postulates/blogs/Ashutosh-Ranjan/8.jpeg",
    link: "/ashutosh_ranjan",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/4.jpg",
    og: "Ashutosh_Ranjan",
    year: "y17",
  },

  {
    name: "Chitwan Garg (Y16)",
    work: "HSBC",
    text: "Hello Everyone! Myself Chitwan Garg Y16, B-Tech graduate in Civil Engineering and a Double Major in Economics. I am a guy who did not have any significant extracurricular involvements during my first year except for those that were made compulsory to remain patriotic to our mother hall with hearts full of hall feeling :p (I enjoyed the escapes from HEC that I made with some of my wingies during takneek).",
    dp: "placement-postulates/dp/Chitwan-Garg.JPG",
    link: "/chitwan_garg",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/3.JPG",
    og: "Chitwan_Garg",
    year: "y16",
  },

  {
    name: "Shuaib Alam (Y18 PG)",
    work: "Hero Future Energies (New Delhi)",
    text: "Hello Everyone! Myself SHUAIB ALAM. I completed my Graduation from JAMIA MILLIA ISLAMIA, NEW DELHI in CIVIL ENGINEERING.",
    dp: "placement-postulates/dp/Shuaib.jpg",
    link: "/shuaib_alam",
    thumbnail: "/img/Student-section/placement-postulates/dp/2.jpg",
    og: "Shuaib_Alam",
    year: "y18",
  },

  {
    name: "Jeetendra Kumar Patel (Y16)",
    work: "IOCL",
    text: "Let me first introduce myself. I am Jeetendra Kumar Patel (Y16), B.Tech in CE, IITK. Currently, I am working in IOCL, I got placed in Phase 2 last year. ",
    dp: "placement-postulates/dp/Jeetendra-Kumar.jpg",
    link: "/jeetendra",
    thumbnail: "/img/Student-section/placement-postulates/thumbnail/1.jpg",
    og: "Jeetendra_Kumar_Patel",
    year: "y16",
  },
 
];

export default chats;
